import Vue from "vue";
import App from "./App.vue";

import router from "@/router";

import "./registerServiceWorker";

import Select2 from "v-select2-component";
Vue.component("Select2", Select2);

import DSOTheme from "./plugins/dso";

Vue.config.productionTip = false;

Vue.use(DSOTheme);

import { ValidationProvider, ValidationObserver } from "vee-validate";
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
require("@/plugins/validate-rules");

import { store } from "./_store";
window.moment = require("moment-timezone");

import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
Vue.component("loading", Loading);

import VueAlertify from "vue-alertify";
Vue.use(VueAlertify, {
  autoReset: true,
  basic: false,
  closable: true,
  closableByDimmer: true,
  frameless: false,
  maintainFocus: true, // <== global default not per instance, applies to all dialogs
  maximizable: true,
  modal: true,
  movable: true,
  moveBounded: false,
  overflow: true,
  padding: true,
  pinnable: true,
  pinned: true,
  preventBodyShift: false, // <== global default not per instance, applies to all dialogs
  resizable: true,
  startMaximized: false,
  transition: "pulse",

  notifier: {
    // auto-dismiss wait time (in seconds)
    delay: 4,
    // default position
    position: "top-right",
    // adds a close button to notifier messages
    closeButton: false
  },
  // language resources
  glossary: {
    // dialogs default title
    title: "DSO Warning !",
    // ok button text
    ok: "OK",
    // cancel button text
    cancel: "Cancel"
  },
  theme: {
    // class name attached to prompt dialog input textbox.
    input: "ajs-input",
    // class name attached to ok button
    ok: "ajs-ok",
    // class name attached to cancel button
    cancel: "ajs-cancel"
  }
});

import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);

//Font awesome
import "@fortawesome/fontawesome-free/css/all.css";

import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
import "sweetalert2/dist/sweetalert2.min.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import VueHolder from "vue-holderjs";
Vue.use(VueHolder);

require("./plugins/argon");

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
